module.exports = __webpack_public_path__ + "img/airklima-home.fdf75a14.jpg";